import { TEXT_PROPS } from './default-props';

// Mood Board Color
export const BG_PRIMARY = '#fff9f2';
export const BG_SECONDARY = '#ae73a8';
export const BG_ALTERNATIVE = '#f6e0bc';
export const BG_LAYER = 'rgba(246,224,188, 0.48)';

// Text Color
export const TEXT_PRIMARY = '#6c7675';
export const TEXT_SECONDARY = '#ae73a8';
export const TEXT_ALTERNATIVE = '#fffbf5';

// Music & Navigation Color
export const NAVIGATION_COLOR = `#9cadca`;
export const ICON_NAVIGATION_COLOR = 'white';

// Default Button Color
export const BUTTON_PROPS = {
  _hover: { opacity: '.8' },
};

export const BUTTON_PADDING_PROPS = {
  ...BUTTON_PROPS,
  ...TEXT_PROPS.body,
  variant: 'solid',
  padding: '18px 24px',
  borderRadius: '8px',
  background: 'bgSecondary',
  color: 'alternativeColorText',
  size: 'sm',
  boxShadow: 'sm',
  fontSize: '18px',
  position: 'relative',
  zIndex: '20',
};

export const DEFAULT_BUTTON_PROPS = {
  fontWeight: 'normal',
};
